export const SET_AUTH_CMS: string = 'SET_AUTH_CMS';
export const RESET: string = 'RESET';

export const SET_AUTH: string = 'SET_AUTH';
export const SET_GUEST_PARTY: string = 'SET_GUEST_PARTY';
